import { graphql } from 'react-apollo';
import { BatchUpdateTasks } from '../../../mutations/BatchUpdateTasks';

const withBatchUpdateTasks = WrappedComponent => graphql(BatchUpdateTasks)(WrappedComponent);
export default withBatchUpdateTasks;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/ManageMenu/withBatchUpdateTasks.js